module.exports = __webpack_public_path__ + "img/brand-story.99e1342a.webp";